import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Usuario, Certificado, ExcluirCertificado, Solicitacao, Emissao, Login } from '../../index';
import { environment } from '../../../../environments/environment';
import { CarteiraCertificado } from '../../model/carteira-certificado';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class CertificadoService {

    constructor(private http: HttpClient) { }

    getListaCertificados(idUsuario : number, idOrganizacao : number): Promise<CarteiraCertificado> {

        const url = environment.backendBaseUrl + `/manager/certificados/listarCertificados/${idUsuario}/${idOrganizacao}`;

        return this.http.get(url)
                .toPromise()
                .then(response =>  response as CarteiraCertificado)
                .catch(this.handleError);

    }

    solicitar(usuario : Usuario) : Observable<Usuario> {
        return this.http.post<Usuario>(environment.backendBaseUrl + `/manager/solicitacoes/${usuario.id}/${usuario.organizacaoId}`, usuario).pipe(
            catchError(this.handleErrorObservable));
    }

    definirSenha(idUsuario: number, login : Login) : Observable<any> {
        return this.http.post(environment.backendBaseUrl + `/manager/certificados/senha/${idUsuario}`, login).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(this.handleErrorObservable));
    }

    getStatusFatores(idUsuario : number, idOrganizacao : number): Observable<any> {
        return this.http.get(environment.backendBaseUrl + `/manager/certificados/statusfatores/${idUsuario}/${idOrganizacao}`).pipe(
            map((res) => {
                return res;
            }),
            catchError((error: HttpErrorResponse | any) => {
                console.error(error.message || error);
                return observableThrowError(error.message || error);
            }));
    }

    private handleErrorObservable (error: HttpErrorResponse | any) {
        console.error(error.error.message);
        return observableThrowError(error.error || error); 
    }

    private handleError(error: any): Promise<any> {
      console.error('OCORREU UM ERRO:', error.error.message);
      return Promise.reject(error.error.message || error);
    }

    getDetalheCertificado(id : number, idUsuario: number): Promise<Certificado> {

          const url = environment.backendBaseUrl + `/manager/certificados/detalhe/${id}/${idUsuario}`;


          return this.http.get(url)
            .toPromise()
            .then(response =>  response as Certificado)
            .catch(this.handleError);

          }

    deleteCertificado(cert: ExcluirCertificado, idUsuario: number, idOrganizacao: number): Promise<void> {
        const url = `${environment.backendBaseUrl}/manager/certificados/remover/${idUsuario}/${idOrganizacao}`;

        return this.http
            .put(url, cert)
            .toPromise()
            .then(() => null)
            .catch(this.handleError);
    }

    emitirCertificadoCorporativo(solicitacao : Solicitacao) : Promise<Certificado> {
        return this.http.post(environment.backendBaseUrl + `/manager/certificados/emitirCertificadoCorporativo`, solicitacao).toPromise()
            .catch(this.handleError)
            .then((res) => {
                let cert = res as Certificado;
                return cert});
    }

    emitirRenovacaoCertificado(usuario: Usuario, emissao: Emissao): Observable<Emissao> {
        return this.http.post<Emissao>(environment.backendBaseUrl
            + `/manager/certificados/emitirRenovacaoCertificado/${usuario.id}/${usuario.organizacaoId}`, emissao).pipe(
            catchError(this.handleErrorObservable));
    }
}